import Image from "next/image";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { chapters } from "@/views/about/constants";
import CustomIcon from "@/components/ui/custom-icon";

interface HeaderProps {
  activeChapterID: number;
  onChapterChange: (chapterID: number) => void;
}

const Tags = ({ activeChapterID, onChapterChange }: HeaderProps) => {
  return (
    <div className={S.wrapper}>
      <div className={S.borderWrapper}>
        <div className={S.border} />
        <CustomIcon fileName="icon-arrow" className={S.borderIcon} />
        <div className={S.border} />
      </div>
      <div className={S.tagsWrapper}>
        {chapters.map(chapter => (
          <button
            key={chapter.id}
            type="button"
            className={S.chapterWrapper}
            data-active={chapter.id === activeChapterID}
            onClick={() => onChapterChange(chapter.id)}
          >
            <span className={S.chapterTitle}>{chapter.tags.title}</span>
            <span className={S.chapterDesc}>{chapter.tags.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const Header = ({ activeChapterID, onChapterChange }: HeaderProps) => {
  return (
    <section className={S.background}>
      <div className={S.backgroundImgWrapper}>
        <Image
          alt="background"
          src="/images/about/background.jpg"
          fill
          priority
          sizes="100vw"
          className={S.bannerImg}
        />
      </div>

      <Container className={S.headerInfo}>
        <h1 className={S.title}>
          ИСТОРИЯ,
          <br /> СОЗДАННАЯ ВРУЧНУЮ
        </h1>
        <Tags activeChapterID={activeChapterID} onChapterChange={onChapterChange} />
      </Container>
    </section>
  );
};

export default Header;
